import { useState } from "react";
import { faqs } from "@/mocks/civicData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span>
            常见问题
            <span className="h-px w-8 bg-primary-400"></span>
          </p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于反映与监督，你想知道的
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-100"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-primary-600"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-heading text-base font-bold text-foreground-900 md:text-lg">
                      {f.q}
                    </span>
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 pl-[4.75rem] text-sm leading-8 text-foreground-600 md:text-base">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}